import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  GetStudyYearCategoryCompanyRequest,
  UpdateStudyYearCategoryCompanyRequest,
  GetStudyYearCategoryCompanyParentRequest,
  GetStudyYearCategoryCompanyHistoryRequest,
} from '@/types/study-year-category-company';
import { studyYearCategoryCompaniesService } from '../../services/study-year-category-companies.service';

export const studyYearCategoryCompanies = {
  /**
   * Get study year category company by ID
   * GET /v3/sy-category-companies/{study_year_category_company_id}
   */
  getStudyYearCategoryCompany: createAsyncThunk(
    'studyYearCategoryCompanies/getStudyYearCategoryCompany',
    async (request: GetStudyYearCategoryCompanyRequest, { rejectWithValue }) => {
      try {
        const response =
          await studyYearCategoryCompaniesService.getStudyYearCategoryCompany(request);
        return response;
      } catch (error: any) {
        return rejectWithValue(
          error.response?.data?.message ||
            `Failed to fetch study year category company ${request.studyYearCategoryCompanyId}`
        );
      }
    }
  ),

  /**
   * Update study year category company
   * PATCH /v3/sy-category-companies/{study_year_category_company_id}
   */
  updateStudyYearCategoryCompany: createAsyncThunk(
    'studyYearCategoryCompanies/updateStudyYearCategoryCompany',
    async (request: UpdateStudyYearCategoryCompanyRequest, { rejectWithValue }) => {
      try {
        const response =
          await studyYearCategoryCompaniesService.updateStudyYearCategoryCompany(request);
        return response;
      } catch (error: any) {
        return rejectWithValue(
          error.response?.data?.message ||
            `Failed to update study year category company ${request.studyYearCategoryCompanyId}`
        );
      }
    }
  ),

  /**
   * Get study year category company parent
   * GET /v3/sy-category-companies/{study_year_category_company_id}/parent
   */
  getStudyYearCategoryCompanyParent: createAsyncThunk(
    'studyYearCategoryCompanies/getStudyYearCategoryCompanyParent',
    async (request: GetStudyYearCategoryCompanyParentRequest, { rejectWithValue }) => {
      try {
        const response =
          await studyYearCategoryCompaniesService.getStudyYearCategoryCompanyParent(request);
        return response;
      } catch (error: any) {
        return rejectWithValue(
          error.response?.data?.message ||
            `Failed to fetch study year category company parent ${request.studyYearCategoryCompanyId}`
        );
      }
    }
  ),

  /**
   * Get study year category company history
   * GET /v3/sy-category-companies/{study_year_category_company_id}/history
   */
  getStudyYearCategoryCompanyHistory: createAsyncThunk(
    'studyYearCategoryCompanies/getStudyYearCategoryCompanyHistory',
    async (request: GetStudyYearCategoryCompanyHistoryRequest, { rejectWithValue }) => {
      try {
        const response =
          await studyYearCategoryCompaniesService.getStudyYearCategoryCompanyHistory(request);
        return response;
      } catch (error: any) {
        return rejectWithValue(
          error.response?.data?.message ||
            `Failed to fetch study year category company history ${request.studyYearCategoryCompanyId}`
        );
      }
    }
  ),
};
